import { Field } from "react-final-form";

import DateAdapter from "./DateAdapter";

export interface DateSelectorProps {
  name: string;
  label: string;
  required: boolean;
  id?: string;
  maxDate?: string | Date;
  disableFuture?: boolean;
}

const DateSelectorComponent = (props: DateSelectorProps) => {
  const isValid = (value: any) => {
    if(props.maxDate && value && value !== "") {
      const maxDate = new Date(props.maxDate);
      maxDate.setHours(0,0,0,0);
      const date = new Date(value);
      date.setHours(0,0,0,0);
      return date < maxDate
      ? undefined
      : `Please enter a valid ${props.label}`;
    }
    return undefined;
  };

  return (
    <Field
      sx={{width: 1}}
      name={props.name}
      validate={isValid}
      label={props.label}
      component={DateAdapter}
      subscription={{ touched: true, value: true, error: true }}
      required={props.required}
      id={props.id ?? props.name}
      disableFuture={props.disableFuture ?? false}
    />
  );
};

export default DateSelectorComponent;
